import { SelectItem } from '@/_components';
import type { FirmAccessType } from '@/_types/roles';

export const FIRM_ACCESS_NAME_MAP: Record<FirmAccessType, string> = {
  basic: 'Basic',
  partner: 'Admin',
  full: 'Staff',
  group: 'Group',
};

export const FIRM_ACCESS_OPTIONS: Array<SelectItem> = Object.keys(
  FIRM_ACCESS_NAME_MAP,
).map((access) => ({
  name: FIRM_ACCESS_NAME_MAP[access as FirmAccessType],
  value: access,
}));
